import { Progress } from "@/components/ui/progress";

/**
 * Barra de progresso + tempo decorrido durante processamento/envio da assinatura.
 */
export function AssinaturaUploadProgressBar({ label, percent, elapsedSeconds }) {
  const safe = Math.min(100, Math.max(0, Number(percent) || 0));
  const sec = Number.isFinite(elapsedSeconds) ? elapsedSeconds : 0;

  return (
    <div className="w-full space-y-2 rounded-lg border border-slate-200 bg-slate-50 p-3">
      <div className="flex items-center justify-between gap-2 text-xs">
        <span className="font-medium text-slate-800">{label || "Processando…"}</span>
        <span className="tabular-nums text-slate-500">{sec.toFixed(1)} s</span>
      </div>
      <Progress
        value={safe}
        className="h-2.5 bg-slate-200"
        indicatorClassName="bg-blue-600 transition-[transform] duration-200 ease-out"
      />
    </div>
  );
}
